import { render, staticRenderFns } from "./ProofFilters.vue?vue&type=template&id=b554e0e4&scoped=true"
import script from "./ProofFilters.vue?vue&type=script&lang=js"
export * from "./ProofFilters.vue?vue&type=script&lang=js"
import style0 from "./ProofFilters.vue?vue&type=style&index=0&id=b554e0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b554e0e4",
  null
  
)

export default component.exports